import * as React from "react";
import { useDispatch } from "react-redux";

import { OPTIONS_HOLIDAYS } from "@config/testIds/options";

import { ThunkActionDispatch } from "@typings/reduxThunkActions";

import { AsyncActionResult } from "@services/AsyncActionCreatorFactory";

import { showToast } from "@containers/Toastify";

import { useTranslate } from "@hooks/useTranslate";

import {
  addHoliday,
  editHoliday,
  fetchHolidays,
  clearProcessedHoliday,
} from "@app/redux/holidays/holidays.actions";
import { fetchJobs2 } from "@app/redux/jobs2/jobs2.actions";
import { useModalStore } from "@app/hooks/useModalStore";

import {
  AddVacation,
  CleaningForHolidays,
  ConfirmHolidayDeletion,
  HolidayModificationBlocked,
} from "./ProfileDashboard/modals";

export enum OPTIONS_MODALS {
  ADD_VACATION = "add-vacation",
  CLEANING_FOR_HOLIDAYS = "cleaning-for-holidays",
  CONFIRM_HOLIDAY_DELETION = "confirm-holiday-deletion",
  HOLIDAY_MODIFICATION_BLOCKED = "holiday-modification-blocked",
}

const OptionsDashboardModals = (): React.ReactElement => {
  const { hideModal } = useModalStore();
  const dispatch = useDispatch<ThunkActionDispatch>();
  const translate = useTranslate();

  const onModalSubmit = async (holidayId?: string) => {
    const { onError, onSuccess } = holidayId
      ? await dispatch<Promise<AsyncActionResult>>(editHoliday())
      : await dispatch<Promise<AsyncActionResult>>(addHoliday());

    await dispatch(fetchHolidays());
    await dispatch(fetchJobs2({}));

    onError(err => {
      showToast(err.message, {
        type: "error",
      });
    });

    onSuccess(() => {
      const translationKey = holidayId
        ? "batmaid_pwa_holidays.holiday_edit_success"
        : "batmaid_pwa_holidays.holiday_add_success";

      showToast(translate(translationKey), {
        type: "success",
        toastId: OPTIONS_HOLIDAYS.NOTIFICATIONS_ADD_HOLIDAY,
      });
    });

    hideModal(OPTIONS_MODALS.ADD_VACATION);
    dispatch(clearProcessedHoliday());
  };

  return (
    <React.Fragment>
      <AddVacation onModalSubmit={onModalSubmit} />
      <CleaningForHolidays onModalSubmit={onModalSubmit} />
      <ConfirmHolidayDeletion />
      <HolidayModificationBlocked />
    </React.Fragment>
  );
};

export { OptionsDashboardModals };
